import React from "react";
import { useTranslation } from "react-i18next";


// New WorkCard component
const WorkCard = ({ image, title, description }) => {
  const { t } = useTranslation("certificates"); // Hook to use translations

  return (
    <div className="p-4 rounded-lg  flex items-start  mt-4">
      <img src={image} alt={title} className="w-16 h-16 rounded-full mr-4" />
      <div className="flex flex-col">
        <div className="max-w-[288px]">

          <h3 className="title-xl text-color-6 tracking-tight">{t(title)}</h3>
          <p className="body-medium text-color-7 mt-4 tracking-[1px]">{t(description)}</p>
        </div>
      </div>
    </div>
  );
};

const GetCertificates = () => {
  const { t } = useTranslation("certificates"); // Hook to use translations

  return (
    <div className="bg-[#1F1F1F] text-white py-12 px-4 md:px-32 ">
      <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row ">
        {/* Left Section */}
        <div className="flex flex-col justify-start text-white mb-6 md:mb-0 md:px-16 md:py-16 text-center md:text-left">
          {/* Welcome Text */}
          <div className="flex flex-row flex-wrap gap-4 mb-2 justify-center md:justify-start">
            <div className="title-small bg-gradient-to-r from-[#05897E] to-[#42FBFE] text-transparent bg-clip-text py-2 px-4 rounded-full mb-2 border border-[#FFFFFF33]">
              {t("hashtag_mining_optimization")}
            </div>
            <div className="title-small bg-gradient-to-r from-[#05897E] to-[#42FBFE] text-transparent bg-clip-text py-2 px-4 rounded-full mb-2 border border-[#FFFFFF33]">
              {t("hashtag_safety_first")}
            </div>
          </div>
          <div className="flex flex-row flex-wrap gap-4 mb-10 justify-center md:justify-start">
            <div className="title-small bg-gradient-to-r from-[#05897E] to-[#42FBFE] text-transparent bg-clip-text py-2 px-4 rounded-full mb-2 border border-[#FFFFFF33]">
              {t("hashtag_innovation_in_mining")}
            </div>
            <div className="title-small bg-gradient-to-r from-[#05897E] to-[#42FBFE] text-transparent bg-clip-text py-2 px-4 rounded-full mb-2 border border-[#FFFFFF33]">
              {t("hashtag_customer_focused")}
            </div>
          </div>
          {/* Main Heading */}
          <h1 className="web-heading-section mb-4">{t("how_to_get_certificate")}</h1>
          {/* Description */}
          <div className="max-w-[438px]">

            <p className="text-color body-large-30 mb-6 md:text-xl max-w-5xl">
              {t("contact_us_certificate")}
            </p>
          </div>
        </div>

        {/* Vertical Separator */}
        <div className="hidden md:block w-px bg-gray-600 mx-4 mr-16 mt-16" />
        {/* Horizantal Separator */}
        <div className="lg:hidden my-4 border-t border-gray-600" />

        {/* Right Section */}
        <div>
          {/* Work Cards */}
          <div className="flex flex-col py-8">
            <WorkCard
              image="./assets/handicon.svg"
              title="meet_eligibility_criteria"
              description="meet_eligibility_criteria_description"

            />
            <WorkCard
              image="./assets/package.svg"
              title="review_and_approval"
              description="review_and_approval_description"
            />
            <WorkCard
              image="./assets/customershield.svg"
              title="receive_certificate"
              description="receive_certificate_description"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetCertificates;
